import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getLocationDocumentListData } from './mockData'
import type { ILocationDocument } from '~/types/document/models'

export const {
  getDocuments: getLocationDocuments,
  postDocument: postLocationDocument,
  patchDocument: patchLocationDocument,
  deleteDocument: deleteLocationDocument,
  handlers,
} = makeDocumentAPIs<ILocationDocument>({
  apiPathEntityNamePrefix: 'location',
  getDocumentListDataFn: getLocationDocumentListData,
})
